import ClientDetail from './ClientDetail';

export default ClientDetail;
